import { useCallback } from 'react'
import { useUser } from 'context/user/user.context'
import type { TransactionalLogActor } from './types'
import type { TransactionalLogEventPayload } from './types'
import { sendLog as sendLogCore } from './sendLog'

function actorFromUser(
  userData: { id?: string } | null
): TransactionalLogActor | null {
  if (!userData?.id) return null
  return {
    type: 'doctor',
    id: userData.id,
    company_id: 'unknown',
  }
}

export function useTransactionalLog(): {
  sendLog: (
    eventName: string,
    payload: TransactionalLogEventPayload,
    options?: { actor?: TransactionalLogActor | null }
  ) => void
} {
  const { userData } = useUser()
  const actor = actorFromUser(userData)

  const sendLog = useCallback(
    (
      eventName: string,
      payload: TransactionalLogEventPayload,
      options?: { actor?: TransactionalLogActor | null }
    ) => {
      sendLogCore(eventName, payload, { actor: options?.actor ?? actor })
    },
    [actor]
  )

  return { sendLog }
}
